module.exports = __webpack_public_path__ + "static/024_Gippsland-7fbe99941a76afea60488bde943b4d6e.jpg";